<template>
  <div class="contact-container">
      <span>Para sugestões, elogios, dúvidas ou qualquer outro assunto, entre em contato conosco pelo email<br/></span>
      <a :href="mailto">{{email}}</a>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
    data() {
        return {
            email: "thinksofttecnologia@gmail.com"
        }
    },
    computed: {
        mailto() {
            return "mailto:" + this.email
        }
    }
}
</script>

<style lang="scss" scoped>
.contact-container {
    display: flex;
    flex-direction: column;
}
</style>